'use client';
import Collapse from './collapse';

import type { CollapseGroupProps } from './collapse.types';

const CollapseGroup = ({ items }: CollapseGroupProps) => {
  return (
    <div className="flex w-full flex-col gap-b">
      {items.map((item) => (
        <Collapse
          key={item.id}
          title={item.title}
          content={item.content}
          defaultOpen={item.defaultOpen}
        />
      ))}
    </div>
  );
};

export default CollapseGroup;
